import { ThemeProvider } from "styled-components";
import { BrowserRouter as Router } from "react-router-dom";
import { useMediaQuery } from "@react-hook/media-query";
import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider";

import client from "@config/client";
import GlobalStyle from "@assets/global";

import { theme } from "@assets/theme";
import Routes from "./routes";

const App = () => {
  theme.isDesktop = useMediaQuery("only screen and (min-width: 768px)");
  return (
    <Router>
      <ApolloProvider client={client}>
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <Routes />
        </ThemeProvider>
      </ApolloProvider>
    </Router>
  );
};

export default App;
